import { SystemStoreInterface } from '../models/system-store.interface';

export const initialSystemState: SystemStoreInterface = {
  isMobileMenuShown: false,
};
